import { useContext } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const ProductPromoPage = ({ end }) => {

	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	
	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, productPromoPage: false}))
		startHere.set((p) => ({ ...p, show: true}))
	}
	
	const steps = [
		{
			target: '.promoFirstStep',
			title: "Create Page",
			content: 'Start creating promo page.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.promoSecondStep',
			title: "Choose Template",
			content: 'Select a design template.',
			disableBeacon: true,
			placement: "bottom",
			path: '/campaign/promo?type=product&step=template'
		},
		{
			target: '.promoThirdStep',
			title: "Customize Template",
			content: 'Customize selected template.',
			disableBeacon: true,
			placement: "bottom",
			action: {
				key: 'TEMPLATE_PROMO_PAGE',
			}
		},
		{
			target: '.promoFourthStep',
			title: "Edit Content",
			content: 'Edit page content here.',
			disableBeacon: true,
			placement: "bottom",
			path: '/campaign/promo/product/customization?step=1',
			action: {
				key: 'TEMPLATE_PROMO_PAGE_DISABLED',
			}
		},
		{
			target: '.promoFifthStep',
			title: "Style Page",
			content: 'Adjust page styles.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.promoSixthStep',
			title: "Page Details",
			content: 'View main page details.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.promoSeventhStep',
			title: "Save Page",
			content: 'Save your promo page.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.promoEigthStep',
			title: "Post Page",
			content: 'Publish your promo page.',
			disableBeacon: true,
			placement: "bottom"
		},
	];
	
	return (
		Boolean(walkthrough.data.productPromoPage) &&
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.productPromoPage)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="productPromoPage" 
			featureName="campaign"
		/>
	);
}
